import { useTranslation } from 'react-i18next'

import { Offer } from '@wwt/entities/search-response'

import { useCancelReservation, useGetReservation } from '@/entities/reservation'
import { useToast } from '@/shared/lib/hooks/useToast'

export const useCancel = (offer: Offer | null) => {
	const cancelMutation = useCancelReservation()
	const reservation = useGetReservation(offer?.IDs.wwtOfferId)

	const { t } = useTranslation()

	const { toast } = useToast()

	const onSubmit = () => {
		if (offer === null) {
			throw new Error('On cancel reservation offer is null')
		}

		const submitToast = toast({
			layer: 'modals',
			duration: Infinity,
			description: t('toastTexts.loading')
		})

		const reservationId = reservation.data?.reservationId

		if (reservationId === undefined) {
			throw new Error('reservationId is undefined on cancel submit')
		}

		cancelMutation
			.mutateAsync(reservationId)
			.then(() => {
				submitToast.update({
					duration: 5000,
					variant: 'success',
					description: t('toastTexts.reservationCancel.success')
				})

				window.location.reload()
			})
			.catch(() => {
				submitToast.update({
					duration: 5000,
					variant: 'error',
					description: t('toastTexts.reservationCancel.success')
				})
			})
	}

	return {
		onSubmit,
		isDisabled: reservation.data?.reservationId === undefined
	}
}
